module.exports = "/cyber/_next/static/images/buySteam-200eef3716129035966f7dea2df59daa.jpg";